import {ActionContext} from 'vuex';
import {DateTime} from 'luxon';
import {loadAll} from '@/api/vendors';
import {TradeBase} from '@/api/common/commonapi';
import _ from 'lodash';

const initState = {
    loadAllTimestamp: null,
    list: [],
    tradeBase:null,
    operateList:[],
};

export default {
    namespaced: true,
    state: initState,
    mutations: {
        setList(state: any, list: Array<any>) {
            state.list.splice(0, state.list.length);
            _.each(list, (item) => {
                state.list.push(item);
            });
            state.loadAllTimestamp = DateTime.local();
        },
        setOperateList(state:any,operateList:Array<any>){
          state.operateList=operateList;
          // console.log("当前的操作权限列表",operateList);
        },
        clearList(state: any) {
            state.list = [];
            state.tradeBase=null;
            console.log('清理数据，重新登录的话需要再查询一次');
            state.loadAllTimestamp = null;
        },
        setTrade(state: any, data) {
          state.tradeBase=data;
        },
    },
    actions: {
        async loadAll({commit}: ActionContext<any, any>) {
            const {list} = await loadAll();
            commit('setList', list)
        },
      async loadTrade({commit}: ActionContext<any, any>) {
            const tradeData = await TradeBase();
            if(tradeData.status) {
              commit('setTrade', tradeData.data);
            }
        }
    }
}
